import { useRouter } from 'next/router'
import NewSecondaryButton from '../Buttons/NewSecondaryButton'
import BookACallButton from '../Buttons/Specials/BookACallButton'
import SectionHeading from './SectionHeading'
import SectionSubText from './SectionSubText'

/**
 * Decorative placeholder card (inline SVG) shown top-left, rotated.
 * Replace with your actual image later if desired.
 */
const PostcardIllustration = () => (
    <img src="/assets/real-estate-postcards/cta-left-card.webp" alt="" />
)

export default function ReadyToElevateCta({
    heading = 'Ready to elevate your strategy?',
    subheading = 'Ready to generate more motivated seller leads with postcards that actually work?',
    primary = { label: 'Book a Free Coaching Call', href: '#' },
    secondary = { label: 'Get Free Samples', href: '#' },
    showDecor = true,
}) {
    const router = useRouter()
    return (
        <section
            aria-labelledby="ready-elevate-heading"
            className="py-10 md:py-14">
            {/* Use footer={false} to avoid implicit global footer duplication if Container supports it */}
            <div className="relative overflow-hidden rounded-3xl md:rounded-[56px]">
                {/* Soft peach-to-white background gradient to match mock */}
                <div className="absolute inset-0 bg-gradient-to-b from-[#fff5ec] via-[#fff5ec]/80 to-white" />

                {/* Decorative card image in top-left */}
                {showDecor && (
                    <div className="absolute -top-10 left-0 md:-top-12">
                        <PostcardIllustration className="w-40 md:w-56 opacity-95" />
                    </div>
                )}

                {/* Content */}
                <div className="relative px-5 md:px-10 py-12 md:py-16">
                    <div className="max-w-3xl mx-auto text-center">
                        <SectionHeading className>
                            <span className="text-[#ED5C2F]">{heading}</span>
                        </SectionHeading>
                        <SectionSubText>{subheading}</SectionSubText>

                        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
                            <BookACallButton>{primary?.label}</BookACallButton>

                            <NewSecondaryButton
                                onClick={() => {
                                    router.push(secondary?.href)
                                }}>
                                {secondary?.label}
                            </NewSecondaryButton>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
